import { auth } from '../firebase/config';

const CACHE_TTL_MS = 20 * 1000;
const responseCache = new Map();
const inflight = new Map();
let cacheGeneration = 0;

const responseFromEntry = (entry) => new Response(entry.body, {
  status: entry.status,
  statusText: entry.statusText,
  headers: entry.headers,
});

const clearCache = () => {
  cacheGeneration += 1;
  responseCache.clear();
};

const executeRequest = async (url, init, cacheKey, cacheable, generation) => {
  const response = await fetch(url, init);
  const entry = {
    body: await response.text(),
    status: response.status,
    statusText: response.statusText,
    headers: Array.from(response.headers.entries()),
    expiresAt: Date.now() + CACHE_TTL_MS,
  };
  if (cacheable && response.ok && generation === cacheGeneration) responseCache.set(cacheKey, entry);
  return entry;
};

export const realtorAutoAdminFetch = async (url, init = {}) => {
  const firebaseUser = auth.currentUser;
  if (!firebaseUser) throw new Error('운영 관리자 로그인이 필요합니다.');

  const method = String(init.method || 'GET').toUpperCase();
  const headers = new Headers(init.headers || {});
  const forceRefresh = headers.get('X-Ieum-Cache-Mode') === 'refresh';
  headers.delete('X-Ieum-Cache-Mode');
  headers.set('Authorization', `Bearer ${await firebaseUser.getIdToken()}`);
  headers.set('Accept', 'application/json');

  const requestInit = {
    ...init,
    method,
    headers,
    credentials: 'include',
    cache: 'no-store',
  };
  const cacheable = method === 'GET';
  const cacheKey = `${firebaseUser.uid}:${method}:${String(url)}`;

  if (!cacheable) clearCache();
  if (cacheable) {
    if (inflight.has(cacheKey)) return responseFromEntry(await inflight.get(cacheKey));
    if (!forceRefresh) {
      const cached = responseCache.get(cacheKey);
      if (cached?.expiresAt > Date.now()) return responseFromEntry(cached);
    }
  }

  const pending = executeRequest(url, requestInit, cacheKey, cacheable, cacheGeneration);
  if (cacheable) inflight.set(cacheKey, pending);
  try {
    const entry = await pending;
    return responseFromEntry(entry);
  } finally {
    if (cacheable) inflight.delete(cacheKey);
  }
};

export const clearRealtorAutoAdminCache = clearCache;
